<template>
  <v-card flat color="transparent" class="mt-n4">
    <v-row>
      <v-col cols="6">
        <v-select
          :items="question.questionOpts"
          filled
          item-text="optLabel"
          item-value="questionOptId"
          dense
          :placeholder="$t('선택')"
          v-model="questionAnswer"
          :error-messages="errorMessage"
          :color="themeColor"
        ></v-select>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { validate } from "vee-validate";
export default {
  props: {
    question: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
    },
    isValid: {
      type: Boolean,
      default: false,
    },
    themeColor: {
      type: String,
      default: "primary"
    },
    responseAnswer: Object,
  },
  computed: {
    questionAnswers() {
      let qa = null;
      if (this.questionAnswer != null) {
        qa = [this.questionAnswer];
      } else {
        qa = [];
      }
      return {
        questionId: this.question.questionId,
        questionMatrixId: null,
        questionAnswerVals: qa,
        questionType: this.question.questionType,
      };
    },
  },
  data() {
    return {
      questionAnswer: null,
      validationOptions: JSON.parse(this.question.validationOptions),
      errorMessage: [],
    };
  },
  methods: {
    async checkValidation() {
      let rules = {};
      if (this.question.required) {
        rules["required"] = true;
      }
      let rst = await validate(this.questionAnswer, rules, { name: "이 " });
      this.$emit("update:isValid", rst.valid);
      this.errorMessage = rst.errors;
    },
    setQuestionAnswer() {
      this.questionAnswer =
        this.responseAnswer.response.length > 0
          ? Number(this.responseAnswer.response[0].answerVal)
          : null;
    },
  },
  watch: {
    async questionAnswer() {
      await this.checkValidation();
      this.$emit("input", this.questionAnswers);
    },
  },
  mounted() {
    if (this.responseAnswer) {
      this.setQuestionAnswer();
    }
    this.$emit("input", this.questionAnswers);
  },
};
</script>

<style>
</style>